import api from "@/requests";
import "@/jsdoc/types/api";

export default {
  namespaced: true,
  state: {
    bundle: {
      status: "Initial",
      load_date: "2021-06-03T15:53:32.595Z",
      update_timestamp: "2021-06-03T15:53:32.595Z",
      type: "MyBank",
      bonus: {},
      loans: [],
      gu_products: [],
      payroll_products: [],
      gold_products: [],
      red_products: [],
      credit_card_products: [],
      privilege_card_products: [],
      deposits: [],
      current_accounts: [],
      wallets: [],
      basic_cards: [],
    },
  },
  mutations: {
    SET_BUNDLE: (state, data) => (state.bundle = data),
  },
  getters: {
    getRedAccounts: (state) => {
      return state.bundle.red_products;
    },
    getGoldAccounts({ bundle }) {
      return bundle.gold_products;
    },
    getBonus: (state) => {
      return state.bundle.bonus;
    },
    getLoans: (state) => {
      return state.bundle.loans;
    },
    getDeposits(state) {
      return state.bundle.deposits;
    },
    getDashboardData: (state) => {
      return state.dashboardData;
    },
  },
  actions: {
    /**
     * @param {import('vuex').Store<{}>} param0
     * @param {CustomRequestParams} options
     * @returns {Promise<Object>}
     */
    async fetchBundle({ commit }, options) {
      const data = await api.get("/api/v1/Accounts/GetBundle", options);
      commit("SET_BUNDLE", data);
      return data;
    },
  },
};
